'use client';

import { REGISTER_COPY } from '@eliadmin/core/src/components/dlz/auth/register/register-copy';
import { RegisterCard } from '@eliadmin/core/src/components/dlz/auth/register/register-card';
import { TextField } from '@eliadmin/core/src/components/dlz/auth/register/register-fields';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/** Figma „Osobné údaje“ (60260:29697): name, surname, phone with the courier note. */
export function PersonalCard() {
  const { t } = useTranslations();

  return (
    <RegisterCard title={t('text198')}>
      <div className="flex flex-col gap-4">
        <div className="grid gap-4 md:grid-cols-2">
          <TextField
            name="name"
            label={t('text33')}
            required
            autoComplete="given-name"
            placeholder={t('text33')}
          />
          <TextField
            name="surname"
            label={t('text34')}
            required
            autoComplete="family-name"
            placeholder={t('text34')}
          />
        </div>
        <TextField
          name="phone"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          label={t('text36')}
          required
          hint={REGISTER_COPY.personal.phoneHint}
          placeholder={REGISTER_COPY.personal.phonePlaceholder}
        />
      </div>
    </RegisterCard>
  );
}
